export const TOP_OVERLAY_CLASS_NAME = 'TopOverlay';

// TODO: Use an existing `utils.colors.gray###` color.
export const TEXT_INPUT_COLOR = '#495057';
